import { Checkbox } from 'antd'
import '../ServicesBar/ServicesBar.css'
import { useState } from "react"
import API from "../../Services/API"
import InfoMailRequest from '../../Requests/InfoMailRequest'
import { validateEmail, validatePhoneNumber, validateString } from '../../../Configurator/Services/Validation'

const ServicesForm = () => {

    let [error, setError] = useState<String | undefined>("")
    let [confirm, setConfirm] = useState<String | undefined>("")

    let [businessName, setBusinessName] = useState<string>("")
    let [name, setName] = useState<string>("")
    let [email, setEmail] = useState<string>("")
    let [phone, setPhone] = useState<string>("")
    let [city, setCity] = useState<string>("")
    let [message, setMessage] = useState<string>("")
    let [privacyCheck, setPrivacyCheck] = useState<boolean>(false)

    async function validateAndSend()
    {
        if(
            !validateString(businessName)
            || !validateString(name)
            || !validateString(email)
            || !validateString(phone)
            || !validateString(city)
        )
        {
            setError("Compilare tutti i campi obbligatori")
            return
        }
        else if
        (
            !validateEmail(email)
        )
        {
            setError("L'email inserita non è valida")
            return
        }
        else if
        (
            !validatePhoneNumber(phone)
        )
        {
            setError("Il numero di telefono inserito non è valido")
            return
        }
        else if
        (
            privacyCheck === false
        )
        {
            setError("E' necessario accettare la privacy policy")
            return
        }
        else
        {
            let res = await API.sendInfoMail({
                business_name: businessName,
                name: name,
                email: email,
                phone: parseInt(phone),
                city: city,
                message: message
            })
            if (res === true)
            {
                setError("")
                setConfirm("Email inviata con successo")
            }
            else
            {
                setConfirm("")
                setError("Errore durante l'invio dell'email, riprovare")
            }
        }
    }

    return (
        <div className='services-bar-form-row'>
            <div className='services-bar-form-column'>
                <input placeholder='Azienda *' className='services-bar-input' value={businessName} onChange={s => setBusinessName(s.target.value)}></input>
                <input placeholder='Nome *' className='services-bar-input' value={name} onChange={s => setName(s.target.value)}></input>
                <input placeholder='Email *' className='services-bar-input' value={email} onChange={s => setEmail(s.target.value)}></input>
                <input placeholder='Telefono *' className='services-bar-input' value={phone} onChange={s => setPhone(s.target.value)}></input>
                <input placeholder='Città *' className='services-bar-input' value={city} onChange={s => setCity(s.target.value)}></input>
                <textarea placeholder='Messaggio' className='services-bar-input' value={message} onChange={s => setMessage(s.target.value)}></textarea>
                <div className='services-bar-checkbox-row'>
                    <Checkbox className='services-bar-checkbox' value={privacyCheck} onChange={s => setPrivacyCheck(s.target.checked)}/>
                    <div className='services-bar-privacy-text'>* Ho letto e accetto la
                        <a className='services-bar-privacy-link' href={`${process.env.REACT_APP_SITE_URL}/privacy-policy/`}> privacy policy.</a>
                    </div>
                </div>
                <div className="input-error-label"> {error} </div>
                <div className="input-confirm-label"> {confirm} </div>
                <button className='services-bar-send-button' onClick={() => validateAndSend()}>Invia</button>
            </div>
            <div className='services-bar-service-column'>
                <div className='services-bar-purple-text'>
                    Le offerte Aziende e Liberi Professionisti DigitalReti sono<br></br>
                    personalizzabili in base alle esigenze di connettività e<br></br>
                    possono essere implementate con tutti i nostri servizi.<br></br>
                    Compila il form e sarai ricontattato per cercare insieme<br></br>
                    la soluzione più adatta alle tue necessità
                </div>
                <a className='services-bar-purple-link' href={`${process.env.REACT_APP_SITE_URL}/servizi/`}>
                    <button className='services-bar-purple-button'>
                        Scopri i servizi
                    </button>
                </a>
            </div>
        </div>
    )
}

export default ServicesForm
